import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { observer } from 'mobx-react';
const b = bemClassBuilder('v-range-input');
export const RangeInput = observer(props => {
    const { className, onChange, onChangeValue } = props, inputProps = __rest(props, ["className", "onChange", "onChangeValue"]);
    const handleChange = event => {
        onChange === null || onChange === void 0 ? void 0 : onChange(event);
        onChangeValue === null || onChangeValue === void 0 ? void 0 : onChangeValue(event.target.value);
    };
    return (_jsx("div", Object.assign({ className: b.block(undefined, className) }, { children: _jsx("input", Object.assign({}, inputProps, { type: "range", className: b.element('input'), onChange: handleChange })) })));
});
RangeInput.displayName = 'RangeInput';
